/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const MultipleUsersDealers = (props) => {

    const [values, setValues] = useState([]);
    const elementRef = useRef();

    useEffect(() => {

        const data = props.label === 'USER_ID' ? props.userDetails.userId.split(',') : props.userDetails.dealerAccount.split(',');
        if (data[0] === '') {

            setValues([]);

        } else {

            setValues([...data]);

        }

    }, [props.userDetails.userId, props.userDetails.dealerAccount, props.label]);

    const handleChange = (i, event) => {

        const value = [...values];
        value[i] = event.target.value;
        setValues(value);

    };

    const addClick = (event) => {

        const data = event.target == null ? '' : event.target.value;
        setValues((prevState) => [...prevState, data]);
        event.target.value = '';

    };

    const handlePaste = (event) => {

        const text = event.clipboardData.getData('Text');
        event.preventDefault();
        let data = text.split(/\n|[',']/);
        data = data.map((x) => x.trim());
        setValues((prevValues) => [...prevValues, ...data]);

    };

    return (

        <div className="multiple-users-dealers">
            <div className="users-dealers-headers">
                <div id="invisiblediv" />
                <div><FormattedMessage id={props.label} /></div>
                <span
                    className="icon-close-small"
                    onClick={props.onClose}
                />
            </div>
            <div className="users-dealers-body">
                {
                    values.map((el, i) => el !== '\r' && el !== '' &&
                    <input type="text" value={el || ''} onPaste={handlePaste} onChange={(event) => handleChange(i, event)} />)
                }
                <input type="text" ref={elementRef} placeholder="Paste Here" onPaste={handlePaste} onBlur={(event) => addClick(event)} />
            </div>
            <div className="users-dealers-footer">
                <button
                    type="button"
                    onClick={() => {

                        setValues([]); props.handleSubmit(props.label, '');

                    }}
                >
Clear
                </button>
                <button type="button" id="save" onClick={() => props.handleSubmit(props.label, values.filter((x) => x !== '\r' && x !== '').join(','))}>Save</button>
            </div>
        </div>
    );

};

MultipleUsersDealers.propTypes = {
    userDetails: PropTypes.object.isRequired,
    label: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

export default MultipleUsersDealers;
